import { useState } from 'react';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import ThumbnailItem from '../ThumbnailItem';
import MediaViewer from "components/MediaViewer";
import './FileGrid.scss';


const FileGrid = ({
  files,
  onRemoveFile,
  uploading,
  videoFiles,
  imageFiles,
}) => {
    const [show, setShow] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePreview = (file) => {
        const fileIndex = files.findIndex(f => f.id === file.id);
        setCurrentIndex(fileIndex);
        setShow(true);
    };

    const togglePreview = () => {
        setShow(!show);
    }

    return (
        <div className="file-flex">
            {files.map(file => (
                <ThumbnailItem
                    key={file.id}
                    file={file}
                    onRemove={ onRemoveFile }
                    uploading={ uploading }
                    onPreview={ handlePreview }
                />
            ))}
            <div className="file-count-display">
                {I18n.t('selected')}&nbsp;
                {videoFiles.length > 0 && <span>{ videoFiles.length }&nbsp;{I18n.t('videos')}</span>}
                {videoFiles.length > 0 && imageFiles.length > 0 && <>&nbsp;</>}
                {imageFiles.length > 0 && <span>{ imageFiles.length }&nbsp;{I18n.t('images')}</span>}
            </div>
            <MediaViewer
                show={ show }
                fileIndex={ currentIndex }
                files={ files }
                togglePreview={ togglePreview }
            />
        </div>
    );
};

FileGrid.propTypes = {
    files: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        thumbnailUrl: PropTypes.string,
        status: PropTypes.string,
        progress: PropTypes.number,
    })).isRequired,
    onRemoveFile: PropTypes.func,
    uploading: PropTypes.bool,
    videoFiles: PropTypes.array,
    imageFiles: PropTypes.array,
};

FileGrid.defaultProps = {
    onRemoveFile: null,
    uploading: false,
    videoFiles: [],
    imageFiles: [],
};

export default FileGrid;
